/**
 * Horizon overrides for Shopify.actions.
 */
function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer?.open) drawer.open();
      else window.location.href = Theme.routes.cart_url || '/cart';
    },
  });
}

if (window.Shopify?.actions) init();
else document.addEventListener('DOMContentLoaded', init, { once: true });

const storefrontEnhancementStyles = document.createElement('style');
storefrontEnhancementStyles.textContent = `
  .variant-option > legend {
    width: 100%;
  }
  .size-guide-trigger {
    float: right;
    appearance: none;
    border: 0;
    border-bottom: 1px solid currentColor;
    background: transparent;
    color: inherit;
    padding: 0;
    margin: 0;
    font: inherit;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .08em;
    line-height: 1.5;
    cursor: pointer;
  }
  .size-guide-trigger:hover { opacity: .65; }
  .size-guide-dialog {
    width: min(760px, calc(100vw - 28px));
    max-height: min(82vh, 760px);
    padding: 0;
    border: 0;
    border-radius: 4px;
    color: #171717;
    background: #fff;
    box-shadow: 0 24px 70px rgba(0,0,0,.28);
  }
  .size-guide-dialog::backdrop { background: rgba(0,0,0,.55); }
  .size-guide-dialog__header {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 22px;
    border-bottom: 1px solid #e5e5e5;
    background: #fff;
  }
  .size-guide-dialog__title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
  }
  .size-guide-dialog__close {
    appearance: none;
    border: 0;
    background: transparent;
    color: inherit;
    width: 36px;
    height: 36px;
    padding: 6px;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
  }
  .size-guide-dialog__content {
    overflow: auto;
    padding: 6px 22px 24px;
  }
  .size-guide-dialog__content > div { display: block !important; margin: 0 !important; }
  .size-guide-dialog__content h3 { display: none; }
  .purchase-reassurance {
    display: grid;
    justify-items: center;
    gap: 6px;
    width: 100%;
    margin-top: 10px;
    color: currentColor;
    font-size: 11px;
    font-weight: 650;
    letter-spacing: .055em;
    line-height: 1.4;
    text-align: center;
  }
  .purchase-reassurance__item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .purchase-reassurance__icon { width: 15px; height: 15px; flex: 0 0 15px; }
  @media (max-width: 480px) {
    .size-guide-dialog__header { padding: 14px 16px; }
    .size-guide-dialog__content { padding: 4px 16px 18px; }
    .size-guide-dialog__title { font-size: 19px; }
    .purchase-reassurance { font-size: 10px; letter-spacing: .03em; }
  }
`;
document.head.append(storefrontEnhancementStyles);

function ensureSizeGuideDialog(guide) {
  let dialog = document.querySelector('#oversize-size-guide-dialog');
  if (dialog) return dialog;

  dialog = document.createElement('dialog');
  dialog.id = 'oversize-size-guide-dialog';
  dialog.className = 'size-guide-dialog';
  dialog.setAttribute('aria-labelledby', 'oversize-size-guide-title');

  const content = guide.cloneNode(true);
  content.removeAttribute('id');
  content.hidden = false;

  dialog.innerHTML = `
    <div class="size-guide-dialog__header">
      <h2 class="size-guide-dialog__title" id="oversize-size-guide-title">Size Guide</h2>
      <button class="size-guide-dialog__close" type="button" aria-label="Close size guide">&times;</button>
    </div>
    <div class="size-guide-dialog__content"></div>
  `;
  dialog.querySelector('.size-guide-dialog__content').append(content);
  dialog.querySelector('.size-guide-dialog__close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  document.body.append(dialog);
  return dialog;
}

function addStorefrontEnhancements() {
  const guide = document.querySelector('#oversize-tee-size-guide');

  if (guide) {
    const dialog = ensureSizeGuideDialog(guide);
    guide.hidden = true;

    document.querySelectorAll('variant-picker fieldset').forEach((fieldset) => {
      const sizeInput = fieldset.querySelector('input[data-option-name="Size"]');
      const legend = fieldset.querySelector(':scope > legend');
      if (!sizeInput || !legend || legend.querySelector('.size-guide-trigger')) return;

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'size-guide-trigger';
      trigger.textContent = 'SIZE GUIDE';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.addEventListener('click', () => dialog.showModal());
      legend.append(trigger);
    });
  }

  document.querySelectorAll('product-form-component .product-form-buttons').forEach((buttons) => {
    if (buttons.querySelector('.purchase-reassurance')) return;

    const reassurance = document.createElement('div');
    reassurance.className = 'purchase-reassurance';
    reassurance.setAttribute('role', 'note');
    reassurance.innerHTML = `
      <span class="purchase-reassurance__item">FREE SHIPPING — NO ADDITIONAL SHIPPING CHARGES</span>
      <span class="purchase-reassurance__item">
        <svg class="purchase-reassurance__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7 10V8a5 5 0 0 1 10 0v2m-9 0h8a2 2 0 0 1 2 2v7H6v-7a2 2 0 0 1 2-2Zm2 0V8a2 2 0 1 1 4 0v2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        SECURE &amp; ENCRYPTED PAYMENT
      </span>
    `;
    buttons.append(reassurance);
  });
}

addStorefrontEnhancements();
document.addEventListener('DOMContentLoaded', addStorefrontEnhancements, { once: true });
new MutationObserver(addStorefrontEnhancements).observe(document.documentElement, { childList: true, subtree: true });
